import axios from 'axios';
import { mp } from './analytics';

export const decodeVin = async (vin: string): Promise<any> => {
  const url = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVINValuesBatch/';
  const postFields = new URLSearchParams({
    format: 'json',
    data: vin,
  });

  const startTime = Date.now();
  // Analytics get the manufacturer prefix (WMI, first 3 characters) only,
  // never the VIN.
  const wmi = String(vin || '').slice(0, 3).toUpperCase();

  try {
    const response = await axios.post(url, postFields.toString(), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      timeout: 8000,
    });

    const latency = Date.now() - startTime;

    if (response.data.Results && response.data.Results.length > 0) {
      mp.track('VIN API Success', {
        wmi,
        latency_ms: latency,
        hour_of_day: new Date().getHours(),
        day_of_week: new Date().getDay(),
      });

      return response.data.Results[0];
    }

    mp.track('VIN API Failed', {
      wmi,
      latency_ms: latency,
      error_message: 'No results found',
      hour_of_day: new Date().getHours(),
    });
    throw new Error('No results found');
  } catch (error: any) {
    const latency = Date.now() - startTime;

    mp.track('VIN API Failed', {
      wmi,
      latency_ms: latency,
      error_message: error.message || 'Network error',
      error_code: error.code,
      hour_of_day: new Date().getHours(),
      is_timeout: error.code === 'ECONNABORTED',
    });

    console.error('Failed to decode VIN:', error);
    throw error;
  }
};
